
import moment from 'moment';
import { Component, Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import LoadingIndicator from '../Generics/LoadingIndicator.vue';
import { formattedDate, getValueByType } from '../../utils/date-handlers'
import { UnitLabels, UnitType } from '../../../shared/types/values/unitLabels'
import { InjectionKey } from '../../injection-keys';
import { IndicatorStyle, TenantConfig } from '../../../tenants/types';
@Component({
    components: {
        LoadingIndicator
    }
})
export default class LabelWithValue extends Vue {
    @Prop({default: ''}) label: string;
    @Prop({default: ''}) infoText: string;
    @Prop({default: false}) loading: boolean;
    @Prop({default: null}) value: string | null;
    @Prop({default: null}) unit: UnitType;
    @Prop({default: "100"}) minWidth: string;
    @Prop({default: "100"}) valueMinWidth: string | number;
    @Prop({ type: Boolean, default: false }) valueOnly!: boolean;
    @Inject({ from: InjectionKey.Tenant, default: null }) readonly tenant!: TenantConfig | null;

    /**
     * `IndicatorStyle.Compact`: la tarjeta del valor ocupa solo su contenido (alto fijo 25px).
     * `IndicatorStyle.Fluid` (default): la tarjeta se estira y el texto largo hace wrap.
     */
    get compact(): boolean {
        return !this.valueOnly && !!this.tenant && this.tenant.branding.indicatorStyle === IndicatorStyle.Compact;
    }

    get rootClasses() {
        if (this.compact) {
            return 'd-flex align-items-center';
        }
        return ['label-with-value-root', this.valueOnly ? 'label-with-value-root--value-only' : 'd-flex'];
    }

    get cardClasses() {
        if (this.compact) {
            return 'ml-2 card-styles--compact value-card--compact';
        }
        return ['card-styles', 'value-card', { 'ml-2': !this.valueOnly }];
    }

    get valueCardMinWidthStyle() {
        if (this.compact) {
            return { 'min-width': `${this.valueMinWidth}px` };
        }
        if (this.valueOnly) {
            return {};
        }
        const raw = this.valueMinWidth;
        const n = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
        const px = Number.isFinite(n) ? n : 100;
        return { minWidth: `min(${px}px, 100%)` };
    }

    get displayValue() {
        const val = this.value;

        // si es null, undefined o un guion, no agregar unidad
        if (val === null || val === undefined || val === '-') {
            return val;
        }

        const unit = this.unit as UnitType | string | null;
        const parsedValue = getValueByType(val, typeof unit === 'string' && (UnitLabels as any)[unit] ? unit : null);

        const unitLabel =
            unit && typeof unit === 'string' && (UnitLabels as any)[unit]
            ? UnitLabels[unit as UnitType]
            : (unit ? String(unit) : '');

        return unitLabel ? `${parsedValue} ${unitLabel}` : parsedValue;
    }

    getValueParsed(value, unit) {
        const parsedValue = getValueByType(value, unit);

        if (unit && UnitLabels[unit]) {
            return `${parsedValue} ${UnitLabels[unit]}`;
        }

        return parsedValue;
        }
    }
